import {toast} from 'react-toastify'
import Swal from 'sweetalert2'
import {Message} from '../../../_metronic/helpers'
import {
  addConfiguration,
  deleteConfigurations,
  getConfigurations,
  getConfigurationsById,
  updateConfigurationById,
} from '../../../api/ConfigurationAPI'
import {DELETE_MESSAGE, UPDATE_MESSAGE} from '../../../utils/contants'
import {AlertProps} from '../../data/AlertDefaults'

export const getConfiguration = (setConfiguration: Function, setAPIStatus: Function) => {
  setAPIStatus((prev: any) => ({...prev, loading: true}))
  getConfigurations().then((res: any) => {
    if (res.statusCode === 200) {
      const configurationsWithIndex = res.data.map((configuration: any, index: number) => ({
        ...configuration,
        index: index + 1,
      }))
      setConfiguration(configurationsWithIndex)
      setConfiguration(res.data)

      setAPIStatus((prev: any) => ({...prev, loading: false}))
    } else {
      setAPIStatus((prev: any) => ({...prev, loading: false, error: res.message}))
    }
  })
}

export const deleteConfiguration = (
  id: string,
  getConfiguration: Function,
  setConfiguration: Function,
  setAPIStatus: Function,
  cancelSubmit: Function,
  setInputField: Function,
  InputField: {
    salaryComponentName: string
    salaryComponentValue: string
    salaryComponentUnit: string
  },
  setEditId: Function,

  setInputError: Function
) => {
  cancelSubmit(setInputField, InputField, setEditId, setInputError)
  Swal.fire({...AlertProps, icon: 'warning', title: DELETE_MESSAGE}).then((result: any) => {
    if (result.isConfirmed) {
      deleteConfigurations(id)
        .then((res: any) => {
          if (res.statusCode === 200) {
            getConfiguration(setConfiguration, setAPIStatus)
            toast.success(res.message)
          } else {
            Message(res.message, 'error')
          }
        })
        .catch((res: any) => {
          Message(res.message, 'error')
        })
    }
  })
}

export const handleSubmit = (
  InputField: {
    salaryComponentName: string
    salaryComponentValue: string
    salaryComponentUnit: string
  },
  getConfiguration: Function,
  setConfiguration: Function,
  setEditId: Function,
  initialState: {
    salaryComponentName: string
    salaryComponentValue: string
    salaryComponentUnit: string
  },
  setInputField: Function,
  editId: string | null,
  cancelSubmit: Function,
  setAPIStatus: Function,
  setInputError: Function,
  valiconfigurationLevelForm: Function,
  setSubmitAPIStatus: Function,
  setIsAddUserModalOpen: Function
) => {
  let { cnt, error } = valiconfigurationLevelForm(InputField);
  setInputError(error);

  if (cnt === 0) {
    if (editId == null) {
      setSubmitAPIStatus((prev: any) => ({ ...prev, loading: true }));
      addConfiguration(InputField).then((res) => {
        if (res.statusCode === 200) {
          toast.success(res.message);
          getConfiguration(setConfiguration, setAPIStatus);
          cancelSubmit(setInputField, initialState, setEditId, setInputError);
          setIsAddUserModalOpen(false);
        } else {
          Message(res.message, 'error');
        }
        setSubmitAPIStatus((prev: any) => ({ ...prev, loading: false }));
      });
    } else {
      Swal.fire({ ...AlertProps, icon: 'warning', title: UPDATE_MESSAGE }).then((result: any) => {
        if (result.isConfirmed) {
          setSubmitAPIStatus((prev: any) => ({ ...prev, loading: true }));
          updateConfigurationById(InputField, editId).then((res: any) => {
            if (res.statusCode === 200) {
              getConfiguration(setConfiguration, setAPIStatus);
              toast.success(res.message);
              cancelSubmit(setInputField, initialState, setEditId, setInputError);
              setEditId(null);
              setIsAddUserModalOpen(false);
            } else {
              Message(res.message, 'error');
            }
            setSubmitAPIStatus((prev: any) => ({ ...prev, loading: false }));
          });
        }
      });
    }
  }
};


export const getConfigurationById = (
  id: string,
  InputField: {
    salaryComponentName: string
    salaryComponentValue: string
    salaryComponentUnit: string
  },
  setInputField: Function,
  setEditId: Function,
  setInputError: Function
) => {
  getConfigurationsById(id).then((res: any) => {
    if (res) {
      setInputField({
        ...InputField,
        salaryComponentName: res.data.salaryComponentName,
        salaryComponentValue: res.data.salaryComponentValue,
        salaryComponentUnit: res.data.salaryComponentUnit,
      })
      setEditId(id)
      setInputError({})
      window.scrollTo(0, 0)
    } else {
      Message(res.message, 'error') // Assuming the Message function is imported from the correct location
    }
  })
}

export const valiconfigurationLevelForm = (InputField: {
  salaryComponentName: string;
  salaryComponentValue: string;
  salaryComponentUnit: string;
}) => {
  let cnt = 0;
  const error: any = {};

  const minConfigurationLength = 0;
  const maxConfigurationLength = 50;

  const trimmedConfigurationName = InputField.salaryComponentName.trim();
  const trimmedConfigurationDescription = InputField.salaryComponentValue.trim();

  if (!trimmedConfigurationName) {
    cnt = cnt + 1;
    error.salaryComponentName = 'Please enter a Configuration Name.';
  } else if (!/^[A-Za-z\s]+$/.test(trimmedConfigurationName)) {
    cnt = cnt + 1;
    error.salaryComponentName =
      'Please enter a valid Configuration Name using only alphabetic characters.';
  } else if (trimmedConfigurationName.length < minConfigurationLength) {
    cnt = cnt + 1;
    error.salaryComponentName = 'Configuration Name must be at least 2 characters.';
  } else if (trimmedConfigurationName.length > maxConfigurationLength) {
    cnt = cnt + 1;
    error.salaryComponentName = 'Configuration Name must not exceed 50 characters.';
  }

  if (!trimmedConfigurationDescription) {
    cnt = cnt + 1;
    error.salaryComponentValue = 'Please enter a Configuration Value.';
  } else if (
    InputField.salaryComponentUnit === '%' &&
    !/^\d{1,3}(\.\d{1,2})?$/.test(trimmedConfigurationDescription)
  ) {
    cnt = cnt + 1;
    error.salaryComponentValue =
      'Percentage value should be between 0.01 to 100 with a maximum of 2 decimal places.';
  } else if (
    InputField.salaryComponentUnit === '%' &&
    parseFloat(trimmedConfigurationDescription) > 100
  ) {
    cnt = cnt + 1;
    error.salaryComponentValue = 'Percentage value cannot be greater than 100.';
  } else if (
    ['education', 'variable', 'mealCoupon', 'PT'].includes(InputField.salaryComponentName) &&
    !/^\d{1,6}$/.test(trimmedConfigurationDescription)
  ) {
    cnt = cnt + 1;
    error.salaryComponentValue = 'Value must be an integer not exceeding 6 digits.';
  }

  return { error, cnt };
};



export const cancelSubmit = (
  setInputField: Function,
  InputField: {
    salaryComponentName: string
    salaryComponentValue: string
    salaryComponentUnit: string
  },
  setEditId: Function,
  setInputError: Function
) => {
  setEditId(null)
  setInputField(InputField)
  setInputError({})
}
